<div mat-dialog-content
	class="cm-ranch-create-step-content">
	<h3 class="cm-ranch-create-step-heading">
		{{ 'Commodities' | translate }}
	</h3>

	<p class="cm-ranch-create-step-help">
		{{ 'Choose commodities you want to manage.' | translate }}
	</p>

	<button
		class="bk-button bk-create-button cm-ranch-create-add-button"
		(click)="openAddCommodityTypeDialog()">
		<mat-icon class="cm-ranch-create-add-button__icon">add</mat-icon>
		{{'Add a Commodity' | translate }}
	</button>

	<table *ngIf="commodityTypeControls.length > 0"
		class="bk-form__table cm-irrigation-methods-ui__table">
		<colgroup>
			<col span="1" class="cm-irrigation-methods-ui__col1">
			<col span="1" class="cm-irrigation-methods-ui__col2">
			<col span="1" class="cm-irrigation-methods-ui__col4">
		</colgroup>
		<thead>
			<th>
				{{ 'Commodity' | translate }}
			</th>
			<th class="cm-tcell--align-right">
				{{ 'Crop Types' | translate }}
			</th>
			<th>
				{{ 'Action' | translate }}
			</th>
		</thead>
		<tbody>
			<tr *ngFor="let commodityType of commodityTypeControls; let i = index"
				class="cm-table-row--padded"
				(click)="openEditCommodityTypeDialog(i, $event)">
				<td>
					{{ commodityType.get('CommodityTypeName').value | translate }}
				</td>
				<td class="cm-tcell--align-right">
					{{ commodityType.get('CropTypeIds').value.length }}
				</td>
				<td class="cm-irrigation-methods-ui__action">
					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						(click)="openEditCommodityTypeDialog(i, $event)">
						<mat-icon matTooltip="{{ 'Edit' | translate }}">edit</mat-icon>
					</button>

					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						(click)="deleteCommodityType(i, $event)">
						<mat-icon matTooltip="{{ 'Delete' | translate }}">delete</mat-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<div mat-dialog-actions
	align="end">
	<button class="bk-button__delete"
		(click)="cancel()">
		{{ 'Cancel' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium bk-button--text-only bk-dialog__button--secondary"
		(click)="back()">
		{{ 'Back' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium"
		[disabled]="form && !form.valid"
		(click)="next()">
		{{ 'Next Step' | translate }}
	</button>
</div>
